/**
 * Appends suffix re-run for result title
 * @title the current title of the workflow
 */
export function getTemporaryWorkflowTitle(title?: string): string {
    let tempTitle: string = '';
    if (title != null) {
        tempTitle = title.replace(/(\s+re-run\s*#?\d*?)+$/i, '') + ' re-run';
    }
    return tempTitle;
}
